export default __webpack_public_path__ + "static/media/cr3.7e754178.jpg";